<template>
    <span v-if="item">
        <b-form-select class="form-control" v-model="type" @change="notify">
            <b-form-select-option value="">Notify</b-form-select-option>
            <b-form-select-option value="welcome">Welcome</b-form-select-option>
            <b-form-select-option value="trial-expiring">Trial-Expiring</b-form-select-option>
            <b-form-select-option value="review">Review</b-form-select-option>
            <b-form-select-option value="renewal">Renewal</b-form-select-option>
            <b-form-select-option value="syncing" v-if="item.syncAllowed">Syncing</b-form-select-option>
            <b-form-select-option value="syncing-try" v-else>Syncing Try</b-form-select-option>
            <b-form-select-option value="token-issue">Token Issue</b-form-select-option>
            <b-form-select-option value="token-expired">Token Expired</b-form-select-option>
            <b-form-select-option value="feedback">Feedback</b-form-select-option>
            <b-form-select-option value="premium">Premium</b-form-select-option>
            <b-form-select-option value="subscription-expiring">Subsc-Expiring</b-form-select-option>
            <b-form-select-option value="subscription-expired">Subsc-Expired</b-form-select-option>
            <b-form-select-option v-if="item.isActive==0 || item.isPlanExpired==1 || 1==1" value="trial">Trial End</b-form-select-option>
        </b-form-select>
    </span>
</template>
<style scoped>
    
</style>
<script>
import Vue from "vue";
import HttpFactory from '@/mixins/http.factory';
export default Vue.extend({
    mixins:[HttpFactory],	
    data() {
        return {
            type:'',
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        notify(){
            const _self=this;
            _self.params.data.type=_self.type;
            _self.params.context.componentParent.extraCallBackFn5(_self.params);
        }
    }
});
</script>
